module.exports = __webpack_public_path__ + "img/Perks-15.4368b96f.png";